import React from "react";
import { StyledHeroText } from "../styled";
import { Flex } from "Element/Flex";
import dogeBoss from "assets/images/doge-boss.png";
import { DogeBoss, Description, ScholarWrapper } from "./styled";
const Scholarship = () => {
  return (
    <ScholarWrapper
      justifyContent="space-between"
      flexDirection="row"
      flexWrap="nowrap"
      alignItems="center"
    >
      <Flex className="scholar-text" flexDirection="column">
        <StyledHeroText style={{ marginTop: 0 }} textAlign="left">
          Sponsor a scholarship
        </StyledHeroText>

        <Flex flexDirection="column">
          <Description>
            Proceeds from Doge NFT sales sponsor scholarships that create
            opportunities for game jockeys from developing countries to earn
            money and participate as community members.
          </Description>
          <Description>
            Scholarship opportunities will be in various play to earn blockchain
            based games. The gamers in the scholarship program take a 60% cut of
            the earnings, 15% goes to management, and 25% goes towards the
            treasury.
          </Description>
        </Flex>
      </Flex>
      <DogeBoss width={360} src={dogeBoss} alt="" />
    </ScholarWrapper>
  );
};

export default Scholarship;
